import { useState, useEffect } from '@wordpress/element';

import apiFetch from '@wordpress/api-fetch';

import { Spinner } from '@wordpress/components';
import { StyledEngineProvider } from '@mui/material/styles';

import Masonry from '@mui/lab/Masonry';

const PostsTemplate = ({ query, queryId, template }) => {
	const [error, setError] = useState(null);
	const [postsTemplateObj, setPostsTemplateObj] = useState(null);
	const [isLoaded, setIsLoaded] = useState(false);

	useEffect(() => {
		setIsLoaded(false);

		apiFetch({
			path: 'viz/entities/',
			method: 'POST',
			data: {
				query: { ...query, queryId },
				template,
			},
		}).then(
			(result) => {
				setIsLoaded(true);
				setPostsTemplateObj(result);
			},
			(e) => {
				setIsLoaded(true);
				setError(e);
			}
		);
	}, [query]);

	if (error) {
		return <p>ERROR: {error.message}</p>;
	} else if (!isLoaded) {
		return (
			<div className="loading">
				<Spinner />
			</div>
		);
	} else if (postsTemplateObj) {
		return (
			<StyledEngineProvider>
				<Masonry
					sx={{ width: 'auto' }}
					columns={{ xs: 2, sm: 3 }}
					className="viz-results"
				>
					{Object.entries(postsTemplateObj).map(([pId, pHtml]) => (
						<div
							className="viz-results__el"
							key={pId}
							dangerouslySetInnerHTML={{ __html: pHtml }}
						/>
					))}
				</Masonry>
			</StyledEngineProvider>
		);
	}
	return <p>No posts found</p>;
};

export default PostsTemplate;
